// extracted by mini-css-extract-plugin
export default {"container":"styles_container__X4dWd","brandedViewList":"styles_brandedViewList__Inud0","arrow":"styles_arrow__o2QFJ"};